<template lang="html">
<div class="subpage addrule_edit">
    <el-form ref="ruleForm" :model="params" :rules="rules" :show-message="true" label-position="right" label-width="120px">
        <!-- 负责人 -->
        <el-form-item label="负责人" prop="fuzerenList">
            <el-button style="margin-bottom: 5px;" @click="openFzr" type="primary" size="small">添加负责人</el-button>
            <el-table :data="params.fuzerenList" :header-cell-style="{background:'#F3F4F7',color:'#555'}" style="width: 70%" border>
                <el-table-column prop="lawyerName" label="律师">
                </el-table-column>
                <el-table-column prop="lawyerPost" label="职务" width="180">
                </el-table-column>
                <el-table-column width="120" label="操作" header-align="center" align="center">
                    <template slot-scope="scope">
                        <el-button size="mini" type="danger" @click="delFzr( scope.row)">删除</el-button>
                    </template>
                </el-table-column>
            </el-table>
        </el-form-item>
        <!-- 成员 -->
        <el-form-item label="成员" prop="committeeMemberList">
            <el-select style="margin-bottom: 5px;" size="small" v-model="searchValue1" @change="selectChange1" @visible-change="visibleChange1" clearable filterable remote reserve-keyword placeholder="搜索律师" :remote-method="remoteMethod" :loading="loading">
                <el-option v-for="item in options" :key="item.id" :label="item.name" :value="item">
                </el-option>
            </el-select>
            <el-table :data="params.committeeMemberList" :header-cell-style="{background:'#F3F4F7',color:'#555'}" style="width: 80%" border>
                <el-table-column prop="lawyerName" label="姓名">
                </el-table-column>
                <el-table-column prop="cellphone" label="手机号" width="140">
                </el-table-column>
                <el-table-column prop="certificateNo" label="执业证号" width="160">
                </el-table-column>
                <el-table-column width="260" label="操作" header-align="center" align="center">
                    <template slot-scope="scope">
                        <el-button size="mini" type="danger" @click="delMember(scope.row)">删除</el-button>
                    </template>
                </el-table-column>
            </el-table>
        </el-form-item>

    </el-form>

    <el-dialog title="新增负责人" :visible.sync="dialogFzrVisible" @closed="closedDialog" width="360px">
        <el-form :model="formFzr">
            <el-form-item label="律师名称" :label-width="formLabelWidth">
                <el-select v-model="searchValue2" @change="selectChange2" filterable remote reserve-keyword placeholder="搜索律师" :remote-method="remoteMethod" :loading="loading">
                    <el-option v-for="item in options" :key="item.id" :label="item.name" :value="item">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="律师职务" :label-width="formLabelWidth">
                <el-input v-model="formFzr.lawyerPost" autocomplete="off"></el-input>
            </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
            <el-button type="primary" @click="addFzr" size="small">确 定</el-button>
            <el-button @click="dialogFzrVisible = false" size="small">取 消</el-button>
        </div>
    </el-dialog>
</div>
</template>

<script>
import {
    getLawyerInfoList,

} from '@/api/jingshi';

export default {
    props: ['indata'],
    data() {
        return {
            dialogFzrVisible: false,
            loading: false,
            options: [],
            searchValue: '',
            searchValue2: '',
            // formLabelWidth:'20',
            params: {
                fuzerenList: [],
                committeeMemberList: [],
            },
            formFzr: {
                lawyerName: '',
                lawyerPost: '',
                lawyerId: '',
            },
            rules: {
                fuzerenList: [{
                    type: "array",
                    required: true,
                    message: '角色名称不能为空',
                    trigger: 'blur'
                }],
                // committeeMemberList: [{
                //     type: "array",
                //     required: true,
                //     message: '角色名称不能为空',
                //     trigger: 'blur'
                // }],
            }
        }
    },
    watch: {
        indata: function (e) {
            if (e) {
                for (let key in this.params) {
                    if (e.hasOwnProperty(key)) {
                        this.params[key] = e[key];
                    }
                }
                this.handleClassType(this.params.fuzerenList, 'TJingshiCommitteeMember');
                this.handleClassType(this.params.committeeMemberList, 'TJingshiCommitteeMember');
            }
        }
    },
    methods: {
        handleClassType(arr, class_type) {
            if (arr) {
                for (var i = 0; i < arr.length; i++) {
                    if (!arr[i].hasOwnProperty('class_type')) {
                        arr[i]['class_type'] = class_type;
                    }
                }
            }
        },
        visibleChange1(e) {
            if (!e) {
                console.log("关闭了");
            }
        },
        selectChange1(e) {

            var user = {
                lawyerName: e.name,
                lawyerId: e.id,
                cellphone: e.cellphone, //电话
                certificateNo: e.certificateNo, //职业证号
                class_type: 'TJingshiCommitteeMember',
            }
            this.params.committeeMemberList.push(user);
            console.log(this.params.committeeMemberList);
            this.options = [];
            this.searchValue1 = '';

        },
        selectChange2(e) {
            console.log(e);
            this.formFzr.lawyerName = e.name;
            this.formFzr.lawyerId = e.id;
        },
        remoteMethod(query) {
            if (query !== '') {
                this.loading = true;
                var param = {
                    name: query
                }
                getLawyerInfoList(param).then(res => {
                    this.options = res.lawyerInfos;
                    this.loading = false;
                });
            } else {
                this.options = [];
            }
        },
        delMember(row) {
            console.log(row);
            for (var i = 0; i < this.params.committeeMemberList.length; i++) {
                if (this.params.committeeMemberList[i].lawyerId === row.lawyerId) {
                    this.params.committeeMemberList.splice(i, 1);
                }
            }
        },
        delFzr(row) {
            console.log(row);
            for (var i = 0; i < this.params.fuzerenList.length; i++) {
                if (this.params.fuzerenList[i].lawyerId === row.lawyerId) {
                    this.params.fuzerenList.splice(i, 1);
                }
            }
            console.log(this.params.fuzerenList);
        },
        addFzr() {
            var user = {
                lawyerName: this.formFzr.lawyerName,
                lawyerPost: this.formFzr.lawyerPost,
                lawyerId: this.formFzr.lawyerId,
                class_type: 'TJingshiCommitteeMember',
            }
            this.params.fuzerenList.push(user);
            console.log(this.params.fuzerenList);

            this.dialogFzrVisible = false;

        },
        openFzr() {
            this.formFzr = {
                lawyerName: '',
                lawyerPost: '',
                lawyerId: '',
            };
            this.options = [];
            this.searchValue2 = '';
            this.dialogFzrVisible = true;
        },
        closedDialog() {
            console.log('窗口关闭');
            this.formFzr = {
                lawyerName: '',
                lawyerPost: '',
                lawyerId: '',
            };
            this.options = [];
            this.searchValue2 = '';
        },
        saveReturn: function () {
            var vues = this;
            return new Promise((reslove, reject) => {
                vues.$refs.ruleForm.validate((valid) => {
                    if (valid) {
                        reslove(vues.params);
                    } else {
                        reslove(false);
                    }
                })
            })
        }
    },

    created: function () {
        var vues = this;
        if (this.indata) {
            for (let key in this.params) {
                if (this.indata.hasOwnProperty(key)) {
                    this.params[key] = this.indata[key];
                }
            }
            console.log(this.params);
        }
    }
}
</script>

<style lang="scss" scoped>

</style>

<style lang="css">
.subpage.addrule_edit .el-input__inner {
    border-radius: 0px !important;
}

.subpage.addrule_edit .selects {
    width: 240px !important;
}

.subpage.addrule_edit .el-input {
    width: 240px !important;
}
</style>



// WEBPACK FOOTER //
// subpage2.vue?7a919c50